import { getConfigValue, getParamByName } from '../config';

let sessionToken = null;
let sessionTokenRequest = null;

function getUrlToken() {
    return getParamByName('authToken') || getParamByName('token') || null;
}

function getCredentials() {
    return {
        username: getParamByName('username'),
        password: getParamByName('password')
    };
}

function getAuthenticationGatewayUrl() {
    return getConfigValue('AuthenticationGatewayUrl');
}

function requestSessionToken() {
    const { username, password } = getCredentials();
    const gatewayUrl = getAuthenticationGatewayUrl();

    if (!username || !password) {
        return Promise.reject(new Error('Missing username/password credentials.'));
    }

    if (!gatewayUrl) {
        return Promise.reject(new Error('Missing AuthenticationGatewayUrl runtime config.'));
    }

    return fetch(`${gatewayUrl}/sessions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Authentication failed with status ${response.status}.`);
            }

            return response.json();
        })
        .then((session) => {
            sessionToken = session.token;
            return sessionToken;
        });
}

export function getAuthToken() {
    const urlToken = getUrlToken();

    if (urlToken) {
        return Promise.resolve(urlToken);
    }

    if (sessionToken) {
        return Promise.resolve(sessionToken);
    }

    if (!sessionTokenRequest) {
        sessionTokenRequest = requestSessionToken()
            .catch((error) => {
                sessionTokenRequest = null;
                throw error;
            });
    }

    return sessionTokenRequest;
}

export function getCachedAuthToken() {
    return getUrlToken() || sessionToken;
}
